import Nav from "./nav"
import Slider from "./slider"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Slider(jQuery)
})
